import { render, staticRenderFns } from "./DocumentRequirementsConfig.vue?vue&type=template&id=19b7adbf"
import script from "./DocumentRequirementsConfig.vue?vue&type=script&lang=js"
export * from "./DocumentRequirementsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports